export default function PjCard08() {
    return (
        <div
            style={{
                position: "relative",
                zIndex: "10",
                padding: "2em",
                textAlign: "center",
            }}
        >
            <img
                src="/assets/projects/senmy/senmymock.png"
                alt="Senmy website mockup"
                loading="lazy"
                style={{
                    display: "block",
                    width: "30em",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "2em",
                   paddingTop: "2em",
                }}
            />
        </div>
    );
}
